export default "__VITE_ASSET__ka9Ws4lv__"